import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, inject, Injectable, signal } from '@angular/core';
import { KeyValue } from '@angular/common';
import { FolderStatusHistoryObject } from '@libs/types/src/services/object-type/folder/folder-status-history.object';
import {
    FolderSocialStatusEnum,
    folderSocialStatusEnumPriority,
    noCareStatuses,
    socialNoCareStatuses,
} from '../../../../../../../types/src/services/enum/folder-status.enum';
import { dateify } from '../../../../modules/shared/helpers/date.helper';
import { FolderGlobalStore } from '../../../../store/medicalService/folder.global-store';
import { OrganizationGlobalStore } from '../../../../store/organization.global-store';
import { ServiceTypeEnum } from '../../../../../../../types/src/services/enum/service-type.enum';

@Injectable()
export class FolderStatusHistoryWidgetStore extends ComponentStoreV2Factory {

    public readonly folderStore = inject(FolderGlobalStore);
    public readonly organizationStore = inject(OrganizationGlobalStore);

    public currentService = this.organizationStore.getServiceBySignalId(this.folderStore.serviceId);
    public isSocial = computed(() => this.currentService()?.type === ServiceTypeEnum.SOCIAL);
    public isHealthCare = computed(() => this.currentService()?.type === ServiceTypeEnum.HEALTH_CARE);

    public viewAllHistory = signal<boolean>(false);
    public allowViewAllHistory = computed(() => {
        return (this.data.getFolderStatuses()?.items || [])
            .some((it: FolderStatusHistoryObject) =>
                this.isHealthCare() && noCareStatuses.includes(it.status as any) ||
                this.isSocial() && socialNoCareStatuses.includes(it.status as any));
    });

    public history = computed(() => {
        return (this.data.getFolderStatuses()?.items || [])
            .filter((it: FolderStatusHistoryObject) => {
                if (this.viewAllHistory()) {
                    return true;
                }

                return this.isHealthCare() && !noCareStatuses.includes(it.status as any) || this.isSocial() && !socialNoCareStatuses.includes(it.status as any);
            })
            .sort((a: FolderStatusHistoryObject, b: FolderStatusHistoryObject) => {
                const aPriority = folderSocialStatusEnumPriority[a.status as FolderSocialStatusEnum];
                const bPriority = folderSocialStatusEnumPriority[b.status as FolderSocialStatusEnum];

                return aPriority > bPriority ? -1 : 1;
            })
            .reduce((acc: any, it: FolderStatusHistoryObject) => {
                acc.push({
                    key: it.status,
                    value: [dateify(it.dateFrom), dateify(it.dateTo)],
                });
                return acc;
            }, [] as KeyValue<string, any>[]);
    });

    constructor() {
        super();
    }

    public triggerAllHistory(): void {
        this.viewAllHistory.update((it) => !it);
    }
}
